import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-twelve',
  templateUrl: './home-twelve.component.html',
  styleUrls: ['./home-twelve.component.scss']
})
export class HomeTwelveComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
